import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

const Countdown = () => {
  const deadline = new Date('April 28, 2026 18:00:00 GMT+02:00');
  const [days, setDays] = useState(0);
  const [timer, setTimer] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const { t } = useTranslation();

  useEffect(() => {
    const calculateTimeLeft = () => {
      const currentDate = new Date();
      const timeLeft = deadline.getTime() - currentDate.getTime();

      const days = Math.floor(timeLeft / (24 * 60 * 60 * 1000));
      const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
      const minutes = 59 - currentDate.getMinutes();
      const seconds = 59 - currentDate.getSeconds();

      setDays(days);
      setTimer({ hours, minutes, seconds });
    };

    calculateTimeLeft();
    const intervalId = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(intervalId);
  }, [deadline]);

  return (
    <div className="countdown text-center">
      <div className="nigiri mb-3">
        <div className="pb-5">
          <h2 className="text-5xl text-white my-2 ff-accent mb-5 data-nosnippet">Der Vorverkauf startet in:</h2>
          <h3>
            <span className="superhead d-inline-block text-white data-nosnippet">
              {days} Tagen {timer.hours} Stunden <br /> {timer.minutes} Minuten {timer.seconds} Sekunden
            </span>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Countdown);
